import {CtModelRouteData} from "@ctsolution/ct-framework";

export const ItemSupplierRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("itemsupplier");
